<template>
  <div>
    <div style="display: flex;" v-if="selectedBot.jt_express_is_active">
      <v-btn
        color="#FE0012"
        :loading="loadingJt || jtOrder.loading"
        depressed
        dark
        @click.stop="dialogTypeShipping = true"
        style="display: inline-block; margin-right: -5px; border-radius: 20px 0px 0px 0px !important;"
      >
        <v-icon class="mr-1">local_shipping</v-icon>{{ $t('send_by_jt') }}
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="grey"
            v-on="on"
            class="ml-0"
            style="display: inline-block; border-radius: 0 ;background-color:#FE0012 !important;
                          color: white !important;
                          border-color: darkgray;
                          border-radius: 0px 20px 20px 0px !important"
            outline
            icon
          >
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="jtExpressPrintMobileLabel">
            <v-list-tile-title>{{ $t('print_label') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <v-dialog style="z-index: 210" v-model="dialogTypeShipping" persistent width="500">
      <v-card>
        <v-card-title class="mb-0 pb-0">
          <v-layout wrap>
            <v-flex xs6
              ><h2>{{ $t('choose_mode_of_transportation') }}</h2>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn flat fab small @click="dialogTypeShipping = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout></v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="shipWithJt('pick_up')"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer;"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold;">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >local_shipping</v-icon
                      >

                      Pick up</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="shipWithJt('drop_off')"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer;"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold;">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >inventory</v-icon
                      >
                      Drop off</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog style="z-index: 210" v-model="loadingJt" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กรุณารอสักครู่
          <v-progress-linear
            color="#FFFFFF"
            style="border-radius: 5px;"
            class="text-xs-center"
            v-model="jtLoad"
            height="19"
          >
            <strong style="font-size: 14px; color: #FFF;">{{ jtLoad }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PDFMerger from 'pdf-merger-js/browser'
export default {
  props: ['value', 'cbAll'],
  data: function() {
    return {
      dialogTypeShipping: false,
      summary: this.value,
      jtOrder: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      jtLoad: 0,
      loadingJt: false,
      dialogTypeShipping: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },

  methods: {
    async jtExpressPrintMobileLabel() {
      const vm = this
      let selected = vm.summary.filter(el => {
        return vm.cbAll.includes(el.id) && el.jt_express_ref != null
      })
      selected = selected.map(item => item.id)
      if (selected.length<=0 ) {
        vm.$swal({
          title: vm.$t( (vm.cbAll.length != 0) ? 'cant find order shipped by j&t' : 'Choose ordered to print'),
          type: 'error',
          text: '',
          confirmButtonText: vm.$t('Confirm')
        })
      }else{
      vm.loadingJt = true
      const chunkSize = 100
      const ordersGroupId = []
      for (let i = 0; i <= selected.length; i += chunkSize) {
        const chunk = selected.slice(i, i + chunkSize)

        let response = await vm.post(`jt-express/${vm.selectedBot.pageid}/print-mobile-label`, {
          order_ids: chunk
        })
        if (
          response.success &&
          response.result &&
          response.result.responseitems &&
          response.result.responseitems[0] &&
          response.result.responseitems[0].reportUrl
        ) {
          // ordersGroupId.push(response.result.responseitems[0].reportUrl)
          window.open(
            response.result.responseitems[0].reportUrl,
            `${response.result.responseitems[0].reportUrl}_blank`
          )
        } else if (
          ordersGroupId.length > 0 &&
          response.data &&
          response.data.message == 'ORDER_DATA_NOT_FOUND'
        ) {
          ordersGroupId.push(null)
        } else {
          vm.$swal({
            title: vm.$t('Error'),
            type: 'error',
            text: response.data.message,
            confirmButtonText: vm.$t('Confirm')
          })
        }
      }
      if (ordersGroupId.length > 0) {
        const merger = new PDFMerger()
        for (const file of ordersGroupId) {
          if (file !== null) {
            await merger.add(file)
          }
        }

        const mergedPdf = await merger.saveAsBlob()

        const blob = new Blob([mergedPdf], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        window.open(link.href, '_blank')
      }
      }
      vm.loadingJt = false
    },
    async shipWithJt(type) {
      const vm = this
      vm.dialogTypeShipping = false
      let selected = vm.summary.filter(el => {
        return vm.cbAll.includes(el.id) && ['paid'].includes(el.status)
      })
      let notPass = []
      selected.map(item => {
        item.shippingType ? `${item.shippingType}|${type}` : item.shippingType
        let address = item.nameaddress ? item.nameaddress.split(' , ') : null
        if (address.includes('')) {
          notPass.push(item.id)
        }
      })
      if (notPass.length > 0) {
        vm.$swal({
          title: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${notPass}`,
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else {
        selected = selected.map(item => item.id)
        if (selected.length == 0) {
          await vm.$swal({
            title: vm.$t('send_with_jt_paid_only'),
            type: 'warning',
            confirmButtonText: vm.$t('Confirm')
          })
        } else {
          vm.createOrderJt(selected, type)
        }
      }
    },
    async createOrderJt(selected, type) {
      const vm = this
      try {
        vm.jtLoad = 0
        vm.loadingJt = true
        let response = await vm.post(`jt-express/${vm.selectedBot.pageid}/place-order`, {
          order_ids: selected,
          type: type
        })
        if (response.success) {
          await vm.checkJtCreateOrder(selected)
          vm.jtOrder.show = true
          vm.jtOrder.status = 'PENDING'
          vm.jtOrder.interval = setInterval(async () => {
            let responseCreateOrder = await vm.checkJtCreateOrder(selected)
            if (vm.jtOrder.status == 'SUCCESS') {
              vm.loadingJt = false
              vm.dialogTypeShipping = false
              if (vm.jtOrder.interval) clearInterval(vm.jtOrder.interval)
              await vm.$swal.fire({
                title: vm.$t('Success'),
                type: 'success',
                confirmButtonText: vm.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              vm.$emit('onRefresh')
            } else if (vm.jtOrder.status == 'FAILED') {
              let dataFailed = ''
              let failed_answer = ''
              for (let i = 0; i < responseCreateOrder.order_data_failed.length; i++) {
                dataFailed += responseCreateOrder.order_data_failed[i].orderid
                failed_answer += responseCreateOrder.order_data_failed[i].status_message
                if (i < responseCreateOrder.order_data_failed.length - 1) {
                  dataFailed += ','
                  failed_answer += ','
                }
              }

              vm.loadingJt = false
              if (vm.jtOrder.interval) clearInterval(vm.jtOrder.interval)
              if (failed_answer == 'PLACE_ORDER_FAILED') {
                await vm.$swal.fire({
                  title: vm.$t('Error'),
                  html: `ไม่สามารถจัดส่งออเดอร์ ${dataFailed} ได้เนื่องจากข้อมูลไม่ถูกต้องกรุณากรอกข้อมูลให้ครบถ้วน`,
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
              } else {
                await vm.$swal.fire({
                  title: vm.$t('Error'),
                  html: `ไม่สามารถจัดส่งออเดอร์ ${dataFailed} ได้เนื่องจาก ${failed_answer}`,
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true,
                  preConfirm: () =>  vm.$emit('onRefresh')
                })
              }
            }
          }, 5000)
        } else {
          throw new Error('Response was not successful')
        }
      } catch (error) {
        let err = ''
        for (let i = 0; i < selected.length; i++) {
          err += selected[i]
          if (i < selected.length - 1) {
            err += ','
          }
        }
        if (error.response && error.response.data.message == 'INVALID_SHOP_ADDRESS') {
          const result = await vm.$swal.fire({
            title: vm.$t('กรุณาตั้งค่าที่อยู่ผู้ส่ง ก่อนทำการส่งกับ J&T Express'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
          if (result.value) {
            vm.$router.push('/' + vm.currentLang + `/template?tab=ShippingMethod`).catch(() => {})
          }
        } else if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await vm.$swal.fire({
            title: vm.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await vm.$swal.fire({
            title: `ไม่สามารถจัดส่งออเดอร์ต่อไปนี้ได้ ${err}`,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }

        vm.loadingJt = false
      }
    },
    async checkJtCreateOrder(selected) {
      const vm = this
      try {
        let response = await vm.post(`jt-express/${vm.selectedBot.pageid}/verify-place-order`, {
          order_ids: selected
        })
        if (response.success) {
          let data = response.result
          vm.jtLoad = parseInt(((data.total_success + data.total_failed) / data.total_order) * 100)
          let isPending = data.order_data_pending.some(i => i.status.includes('PENDING'))
          if (isPending) {
            vm.jtOrder.status = 'PENDING'
          } else {
            let isFailed = data.order_data_failed.some(i => i.status.includes('FAILED'))
            if (isFailed) {
              vm.jtOrder.status = 'FAILED'
            } else {
              vm.jtOrder.status = 'SUCCESS'
            }
          }
        }
        return response.result
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingJt.vue